import React from 'react';
import { Redirect } from 'react-router-dom';
import RouteWithTitle from 'routes/RouteWithTitle';

const AuthorizedRoute = ({ component: Component, render, isAuthorized, redirect = '/', ...rest }) => {
  const renderFunction = props => <Component {...props} />
  return (
    <RouteWithTitle {...rest} render={isAuthorized ? (render || renderFunction) : () => <Redirect to={redirect} />} />
  )
};

export default AuthorizedRoute
